import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import store from '@/store'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: '/login',
    meta: {title: '登录'},
    component: () => import('@/views/Login/index.vue')
  },
  {
    path: '/iguidance',
    name: '/iguidance',
    meta: {title: '快速登录'},
    component: () => import('@/views/IGuidance/index.vue')
  },
  {
    path: '/re',
    name: '/re',
    meta: {title: '快速登录'},
    component: () => import('@/views/Re/Re.vue')
  },
  {
    path: '/hospital-list',
    name: '/hospital-list',
    meta: {title: '院区选择'},
    component: () => import('@/views/HospitalList/index.vue')
  },
  {
    path: '/',
    component: () => import('@/components/Layout/index.vue'),
    redirect: {path: '/'},
    children: [
      {
        path: '',
        name: '/function-recommendation',
        meta: {
          title: '首页',
          hideNavBar: true,
          showTabbar: true,
          activeTabbarItem: 'home'
        },
        component: () => import('@/views/Home/FunctionRecommendation/index.vue')
      },
      {
        path: 'flow-guidance',
        name: '/flow-guidance',
        meta: {
          title: '流程引导',
          hideNavBar: false,
          showTabbar: false,
          activeTabbarItem: 'home'
        },
        component: () => import('@/views/Home/FlowGuidance/index.vue')
      },
      {
        path: '/knowledge-tools',
        name: '/knowledge-tools',
        meta: {
          title: '健康',
          hideNavBar: true,
          showTabbar: true,
          activeTabbarItem: 'knowledge'
        },
        component: () => import('@/views/KnowledgeTools/KnowledgeTools/index.vue')
      },
      {
        path: 'my',
        name: '/my',
        meta: {
          title: '我的',
          hideNavBar: true,
          showTabbar: true,
          activeTabbarItem: 'my'
        },
        component: () => import('@/views/My/My/index.vue')
      },
      {
        path: 'faq',
        name: '/faq',
        meta: {
          title: '智能助手',
          activeTabbarItem: 'home'
        },
        component: () => import('@/views/Home/IntelligentAssistant/index.vue')
      },
      // 老版本的预问诊
      // {
      //   path: 'pre-consultation',
      //   name: '/pre-consultation',
      //   meta: {
      //     title: '预问诊',
      //     keepAlive: true,
      //     activeTabbarItem: 'knowledge'
      //   },
      //   component: () => import('@/views/KnowledgeTools/PreConsultation/index.vue')
      // },
      // {
      //   path: 'self-check',
      //   name: '/self-check',
      //   meta: {
      //     title: '症状自查',
      //     keepAlive: true,
      //     activeTabbarItem: 'knowledge'
      //   },
      //   component: () => import('@/views/KnowledgeTools/SelfCheck/index.vue')
      // },
      // {
      //   path: 'disease-knowledge',
      //   name: '/disease-knowledge',
      //   meta: {
      //     title: '疾病知识',
      //     keepAlive: true,
      //     activeTabbarItem: 'knowledge'
      //   },
      //   component: () => import('@/views/KnowledgeTools/DiseaseKnowledge/index.vue')
      // },
      // {
      //   path: 'disease-knowledge-details',
      //   name: '/disease-knowledge-details',
      //   meta: {
      //     title: '疾病百科详情',
      //     activeTabbarItem: 'knowledge'
      //   },
      //   component: () => import('@/views/KnowledgeTools/DiseaseKnowledgeDetails/index.vue')
      // },
      // {
      //   path: 'drug-encyclopedia',
      //   name: '/drug-encyclopedia',
      //   meta: {
      //     title: '药品百科',
      //     keepAlive: true,
      //     activeTabbarItem: 'knowledge'
      //   },
      //   component: () => import('@/views/KnowledgeTools/DrugEncyclopedia/index.vue')
      // },
      // {
      //   path: 'drug-knowledge-details',
      //   name: '/drug-knowledge-details',
      //   meta: {
      //     title: '药品百科详情',
      //     activeTabbarItem: 'knowledge'
      //   },
      //   component: () => import('@/views/KnowledgeTools/DrugKnowledgeDetails/index.vue')
      // },
      // {
      //   path: 'finished-drug-product-list',
      //   name: '/finished-drug-product-list',
      //   meta: {
      //     title: '相关成品药',
      //     activeTabbarItem: 'knowledge'
      //   },
      //   component: () => import('@/views/KnowledgeTools/FinishedDrugProductList/index.vue')
      // },
      // {
      //   path: 'department-recommendation',
      //   name: '/department-recommendation',
      //   meta: {
      //     title: '科室推荐',
      //     activeTabbarItem: 'knowledge'
      //   },
      //   component: () => import('@/views/KnowledgeTools/DepartmentRecommendation/index.vue')
      // },
      {
        path: 'report-query',
        name: '/report-query',
        meta: {
          title: '报告查询',
          activeTabbarItem: 'knowledge',
          keepAlive:true
        },
        component: () => import('@/views/KnowledgeTools/ReportQuery/index.vue')
      },
      {
        path: 'test-report',
        name: '/test-report',
        meta: {
          title: '检验报告单',
          activeTabbarItem: 'knowledge'
        },
        component: () => import('@/views/KnowledgeTools/ReportQuery/TestReport.vue')
      },
      {
        path: 'test-report-analysis',
        name: '/test-report-analysis',
        meta: {
          title: '检验解读',
          activeTabbarItem: 'knowledge'
        },
        component: () => import('@/views/KnowledgeTools/ReportQuery/TestReportAnalysis.vue')
      },
      {
        path: 'test-report-item-description',
        name: '/test-report-item-description',
        meta: {
          title: '检验解读',
          activeTabbarItem: 'knowledge'
        },
        component: () => import('@/views/KnowledgeTools/ReportQuery/TestReportItemDescription.vue')
      },
      {
        path: 'exam-report',
        name: '/exam-report',
        meta: {
          title: '检查报告单',
          activeTabbarItem: 'knowledge'
        },
        component: () => import('@/views/KnowledgeTools/ReportQuery/ExamReport.vue')
      },
      {
        path: 'exam-report-explain',
        name: '/exam-report-explain',
        meta: {
          title: '报告解读',
          activeTabbarItem: 'knowledge'
        },
        component: () => import('@/views/KnowledgeTools/ReportQuery/ExamReportExplain.vue')
      },
      {
        path: 'patient-list',
        name: '/patient-list',
        meta: {
          title: '常用就诊人',
          activeTabbarItem: 'my'
        },
        component: () => import('@/views/My/PatientList/index.vue')
      },
      {
        path: 'patient-add',
        name: '/patient-add',
        meta: {
          title: '新增就诊人',
          activeTabbarItem: 'my'
        },
        component: () => import('@/views/My/PatientAdd/index.vue')
      },
      {
        path: 'patient-edit',
        name: '/patient-edit',
        meta: {
          title: '就诊人信息',
          activeTabbarItem: 'my'
        },
        component: () => import('@/views/My/PatientEdit/index.vue')
      },
      {
        path: 'patient-card-binding',
        name: '/patient-card-binding',
        meta: {
          title: '绑定病案号',
          activeTabbarItem: 'my'
        },
        component: () => import('@/views/My/PatientEdit/PatientCardBinding.vue')
      },
      {
        path: 'patient-field-edit',
        name: '/patient-field-edit',
        meta: {
          title: '编辑就诊人',
          activeTabbarItem: 'my'
        },
        component: () => import('@/views/My/PatientFieldEdit/index.vue')
      },
      {
        path: 'account-setting',
        name: '/account-setting',
        meta: {
          title: '账号设置',
          activeTabbarItem: 'my'
        },
        component: () => import('@/views/My/AccountSetting/index.vue')
      },
      {
        path: 'mobile-modification',
        name: '/mobile-modification',
        meta: {
          title: '更换手机号',
          activeTabbarItem: 'my'
        },
        component: () => import('@/views/My/AccountSetting/MobileModification.vue')
      },
      {
        path: 'notice-management',
        name: '/notice-management',
        meta: {
          title: '通知管理',
          activeTabbarItem: 'my'
        },
        component: () => import('@/views/My/NoticeManagement/index.vue')
      },
      {
        path: 'privacy-policy',
        name: '/privacy-policy',
        meta: {
          title: '隐私条款',
          skipAuth: true
        },
        component: () => import('@/views/My/PrivacyPolicy/index.vue')
      },
      {
        path: 'terms-of-service',
        name: '/terms-of-service',
        meta: {
          title: '用户协议',
          skipAuth: true
        },
        component: () => import('@/views/My/TermsOfService/index.vue')
      },
      {
        path: 'operation-guidance',
        name: '/operation-guidance',
        meta: {
          title: '操作指南',
          skipAuth: true
        },
        component: () => import('@/views/My/OperationGuidance/index.vue')
      },
      // 院内知识-菜单
      {
        path: 'hospital-knowledge-handbook/handbook-menu',
        name: '/hospital-knowledge-handbook/handbook-menu',
        meta: {title: '院内知识'},
        component: () => import('@/views/My/HospitalKnowledgeHandbook/HandbookMenu/index.vue')
      },
      // 院内知识-详情
      {
        path: 'hospital-knowledge-handbook/handbook-detail',
        name: '/hospital-knowledge-handbook/handbook-detail',
        meta: {title: '院内知识'},
        component: () => import('@/views/My/HospitalKnowledgeHandbook/HandbookDetail/index.vue')
      },
      {
        path: 'plan-history',
        name: '/plan-history',
        meta: {
          title: '就医历史记录',
          activeTabbarItem: 'my'
        },
        component: () => import('@/views/My/PlanHistory/PlanHistory.vue')
      },
      {
        path: 'feedback',
        name: '/feedback',
        meta: {
          title: '意见反馈',
          activeTabbarItem: 'my'
        },
        component: () => import('@/views/My/Feedback/index.vue')
      },
      {
        path: 'bill-in-court',
        name: '/bill-in-court',
        meta: {
          title: '院内票据',
          activeTabbarItem: 'knowledge'
        },
        component: () => import('@/views/KnowledgeTools/BillInCourt/index.vue')
      },
      {
        path: 'bill-detail',
        name: '/bill-detail',
        meta: {
          title: '查看票据',
          activeTabbarItem: 'knowledge'
        },
        component: () => import('@/views/KnowledgeTools/BillDetail/index.vue')
      },
      {
        path: 'reservation-notice',
        name: '/reservation-notice',
        meta: {
          title: '检查预约须知',
        },
        component: () => import('@/views/ScheduledInspection/ReservationNotice/index.vue')
      },
      {
        path: 'scheduled-list',
        name: '/scheduled-list',
        meta: {
          title: '检查预约列表',
        },
        component: () => import('@/views/ScheduledInspection/ScheduledList/index.vue')
      },
      {
        path: 'reservation-time-selection',
        name: '/reservation-time-selection',
        meta: {
          title: '检查时间选择',
        },
        component: () => import('@/views/ScheduledInspection/ReservationTimeSelection/index.vue')
      },
      {
        path: 'reservation-confirmation',
        name: '/reservation-confirmation',
        meta: {
          title: '检查预约',
        },
        component: () => import('@/views/ScheduledInspection/ReservationConfirmation/index.vue')
      },
      {
        path: 'reservation-success',
        name: '/reservation-success',
        meta: {
          title: '检查预约',
        },
        component: () => import('@/views/ScheduledInspection/ReservationSuccess/index.vue')
      },
      
    ]
  },
  // 新版本的预问诊
  {
    path: '/pre-consultation',
    component: () => import('@/components/third-party/Layout/index.vue'),
    redirect: {path: '/pre-consultation/patient-info'},
    children: [
      {
        path: 'patient-info',
        name: '/pre-consultation/patient-info',
        meta: {
          title: '患者信息'
        },
        component: () => import('@/views/third-party/PreConsultation/PatientInfo/index.vue')
      },
      {
        path: 'symptom-inference',
        name: '/pre-consultation/symptom-inference',
        meta: {
          title: '症状选择'
        },
        component: () => import('@/views/third-party/PreConsultation/SymptomInference/index.vue')
      },
      {
        path: 'symptom-list',
        name: '/pre-consultation/symptom-list',
        meta: {
          title: '症状选择'
        },
        component: () => import('@/views/third-party/PreConsultation/SymptomList/index.vue')
      },
      {
        path: 'ai-chat',
        name: '/pre-consultation/ai-chat',
        meta: {
          title: '预问诊',
          keepAlive: true
        },
        component: () => import('@/views/third-party/PreConsultation/AiChat/index.vue')
      },
      {
        path: 'medical-record',
        name: '/pre-consultation/medical-record',
        meta: {
          title: '医生端信息',
          keepAlive: true
        },
        component: () => import('@/views/third-party/PreConsultation/MedicalRecord/index.vue')
      }
    ]
  },
  // 智能自诊
  {
    path: '/self-diagnosis',
    component: () => import('@/components/third-party/Layout/index.vue'),
    redirect: {path: '/self-diagnosis/patient-info'},
    children: [
      {
        path: 'patient-info',
        name: '/self-diagnosis/patient-info',
        meta: {
          title: '患者信息'
        },
        component: () => import('@/views/third-party/SelfDiagnosis/PatientInfo/index.vue')
      },
      {
        path: 'symptom-inference',
        name: '/self-diagnosis/symptom-inference',
        meta: {
          title: '症状选择'
        },
        component: () => import('@/views/third-party/SelfDiagnosis/SymptomInference/index.vue')
      },
      {
        path: 'symptom-list',
        name: '/self-diagnosis/symptom-list',
        meta: {
          title: '症状选择'
        },
        component: () => import('@/views/third-party/SelfDiagnosis/SymptomList/index.vue')
      },
      {
        path: 'ai-chat',
        name: '/self-diagnosis/ai-chat',
        meta: {
          title: '智能自诊'
        },
        component: () => import('@/views/third-party/SelfDiagnosis/AiChat/index.vue')
      }
    ]
  },
  // 智医在线
  {
    path: '/ai-doctor',
    component: () => import('@/components/third-party/Layout/index.vue'),
    children: [
      {
        path: '',
        name: '/ai-doctor',
        meta: {
          title: '智医在线'
        },
        component: () => import('@/views/third-party/AiDoctor/index.vue')
      }
    ]
  },
  // 健康百科首页
  {
    path: '/',
    component: () => import('@/components/third-party/HeLayout/HeLayout.vue'),
    children: [
      {
        path: 'health-encyclopedia',
        name: '/health-encyclopedia',
        meta: {
          title: '健康百科'
        },
        component: () => import('@/views/third-party/HealthEncyclopedia/index.vue')
      }
    ]
  },
  // 疾病知识
  {
    path: '/',
    component: () => import('@/components/third-party/HeLayout/HeLayout.vue'),
    children: [
      {
        path: 'disease-search',
        name: '/disease-search',
        meta: {
          title: '疾病知识',
          navBarTitle: '疾病知识'
        },
        component: () => import('@/views/third-party/DiseaseKnowledge/DiseaseSearch/index.vue')
      },
      {
        path: 'disease-detail/:id',
        name: '/disease-detail',
        meta: {
          title: '疾病知识',
          navBarTitle: '疾病知识'
        },
        component: () => import('@/views/third-party/DiseaseKnowledge/DiseaseDetail/index.vue')
      }
    ]
  },
  // 用药助手
  {
    path: '/',
    component: () => import('@/components/third-party/HeLayout/HeLayout.vue'),
    children: [
      {
        path: 'drug-assistant',
        name: '/drug-assistant',
        meta: {
          title: '用药助手',
          navBarTitle: '用药助手'
        },
        component: () => import('@/views/third-party/DrugAssistant/DrugAssistant/index.vue')
      },
      {
        path: 'drug-search',
        name: '/drug-search',
        meta: {
          title: '用药助手',
          navBarTitle: '用药助手'
        },
        component: () => import('@/views/third-party/DrugAssistant/DrugSearch/index.vue')
      },
      {
        path: 'product-drug-search/:name',
        name: '/product-drug-search',
        meta: {
          title: '用药助手',
          navBarTitle: '用药助手'
        },
        component: () => import('@/views/third-party/DrugAssistant/ProductDrugSearch/index.vue')
      },
      {
        path: 'product-drug-list/:name',
        name: '/product-drug-list',
        meta: {
          title: '用药助手'
        },
        component: () => import('@/views/third-party/DrugAssistant/ProductDrugList/index.vue')
      },
      {
        path: 'product-drug-detail/:id',
        name: '/product-drug-detail',
        meta: {
          title: '用药助手'
        },
        component: () => import('@/views/third-party/DrugAssistant/ProductDrugDetail/index.vue')
      },
      {
        path: 'drug-category/:firstClass',
        name: '/drug-category',
        meta: {
          title: '用药助手',
          keepAlive: true
        },
        component: () => import('@/views/third-party/DrugAssistant/DrugCategory/index.vue')
      }
    ]
  },
  // 检查检验
  {
    path: '/',
    component: () => import('@/components/third-party/HeLayout/HeLayout.vue'),
    children: [
      {
        path: 'exam-test',
        name: '/exam-test',
        meta: {
          title: '检查检验百科',
          navBarTitle: '检查检验百科'
        },
        component: () => import('@/views/third-party/ExamTest/ExamTest/index.vue')
      },
      {
        path: 'exam-test-search',
        name: '/exam-test-search',
        meta: {
          title: '检查检验百科',
          navBarTitle: '检查检验百科'
        },
        component: () => import('@/views/third-party/ExamTest/ExamTestSearch/index.vue')
      },
      {
        path: 'exam-test-search-result/:keyword',
        name: '/exam-test-search-result',
        meta: {
          title: '检查检验百科'
        },
        component: () => import('@/views/third-party/ExamTest/ExamTestSearchResult/index.vue')
      },
      {
        path: 'exam-list/:keyword',
        name: '/exam-list',
        meta: {
          title: '检查检验百科'
        },
        component: () => import('@/views/third-party/ExamTest/ExamList/index.vue')
      },
      {
        path: 'test-indicator-list/:keyword',
        name: '/test-indicator-list',
        meta: {
          title: '检查检验百科'
        },
        component: () => import('@/views/third-party/ExamTest/TestIndicatorList/index.vue')
      },
      {
        path: 'exam-detail/:id',
        name: '/exam-detail',
        meta: {
          title: '检查检验百科'
        },
        component: () => import('@/views/third-party/ExamTest/ExamDetail/index.vue')
      },
      {
        path: 'test-indicator-detail/:id',
        name: '/test-indicator-detail',
        meta: {
          title: '检查检验百科'
        },
        component: () => import('@/views/third-party/ExamTest/TestIndicatorDetail/index.vue')
      },
      {
        path: 'test-indicator-category/:category',
        name: '/test-indicator-category',
        meta: {
          title: '检查检验百科'
        },
        component: () => import('@/views/third-party/ExamTest/TestIndicatorCategory/index.vue')
      }
    ]
  },
  // 诊断查询
  {
    path: '/',
    component: () => import('@/components/third-party/HeLayout/HeLayout.vue'),
    children: [
      {
        path: 'diagnosis-query',
        name: '/diagnosis-query',
        meta: {
          title: '诊断查询',
          navBarTitle: '诊断查询'
        },
        component: () => import('@/views/third-party/DiagnosisQuery/DiagnosisQuery/index.vue')
      },
      {
        path: 'diagnosis-search',
        name: '/diagnosis-search',
        meta: {
          title: '诊断查询',
          navBarTitle: '诊断查询'
        },
        component: () => import('@/views/third-party/DiagnosisQuery/DiagnosisSearch/index.vue')
      },
      {
        path: 'diagnosis-search-result/:keyword',
        name: '/diagnosis-search-result',
        meta: {
          title: '诊断搜索结果',
          navBarTitle: '诊断搜索结果'
        },
        component: () => import('@/views/third-party/DiagnosisQuery/DiagnosisSearchResult/index.vue')
      },
      {
        path: 'diagnosis-result-list/:keyword',
        name: '/diagnosis-result-list',
        meta: {
          title: '诊断搜索结果',
          navBarTitle: '诊断搜索结果'
        },
        component: () => import('@/views/third-party/DiagnosisQuery/DiagnosisResultList/index.vue')
      },
      {
        path: 'diagnosis-detail/:id',
        name: '/diagnosis-detail',
        meta: {
          title: '诊断详情',
          navBarTitle: '诊断详情'
        },
        component: () => import('@/views/third-party/DiagnosisQuery/DiagnosisDetail/index.vue')
      },
    ]
  },
  //症状查询
  {
    path: '/',
    component: () => import('@/components/third-party/HeLayout/HeLayout.vue'),
    children: [
      {
        path: 'symptom-query',
        name: '/symptom-query',
        meta: {
          title: '症状查询',
          navBarTitle: '症状查询'
        },
        component: () => import('@/views/third-party/SymptomQuery/SymptomQuery/index.vue')
      },
      {
        path: 'symptom-search',
        name: '/symptom-search',
        meta: {
          title: '症状查询',
          navBarTitle: '症状查询'
        },
        component: () => import('@/views/third-party/SymptomQuery/SymptomSearch/index.vue')
      },
      {
        path: 'symptom-search-result/:keyword',
        name: '/symptom-search-result',
        meta: {
          title: '症状搜索结果',
          navBarTitle: '症状搜索结果'
        },
        component: () => import('@/views/third-party/SymptomQuery/SymptomSearchResult/index.vue')
      },
      {
        path: 'symptom-result-list/:keyword',
        name: '/symptom-result-list',
        meta: {
          title: '症状搜索结果',
          navBarTitle: '症状搜索结果'
        },
        component: () => import('@/views/third-party/SymptomQuery/SymptomResultList/index.vue')
      },
      {
        path: 'symptom-detail/:id',
        name: '/symptom-detail',
        meta: {
          title: '症状详情',
          navBarTitle: '症状详情'
        },
        component: () => import('@/views/third-party/SymptomQuery/SymptomDetail/index.vue')
      },
    ]
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/Test/index.vue')
  },
  {
    path: '/page-is-not-found',
    name: '/page-is-not-found',
    meta: {title: '404'},
    component: () => import('@/views/ErrorPage/PageIsNotFound.vue')
  },
  {
    path: '/:pathMatch(.*)',
    redirect: {path: '/page-is-not-found'}
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // set nav bar title
  store.commit('healthEncyclopedia/setNavBarTitle', to.meta.navBarTitle)

  document.title = to.meta.title as string + ' | 浙大妇院就医助手'
  if (to.name === '/re' && from.name !== undefined) {
    next({path: '/'})
  }
  next()
})

export default router
